module.exports = __webpack_public_path__ + "static/img/btn_qita_nor.4ca717d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_qita_nor.png
// module id = DHQW
// module chunks = 1